import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { ClientPropertyBalanceListModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  ClientPropertyBalances: new ClientPropertyBalanceListModel(),
  Loading: false,
};

export const PropertyBalancesTableSlice = createSlice({
  name: "ClientTransactionsTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBalancesForAllProperties.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getBalancesForAllProperties.fulfilled, (state, action) => {
        state.ClientPropertyBalances = action.payload;
        state.Loading = false;
      })
      .addCase(getBalancesForAllProperties.rejected, (state) => {
        state.ClientPropertyBalances = new ClientPropertyBalanceListModel();
        state.Loading = false;
      });
  },
});

export const getBalancesForAllProperties = createAsyncThunk<ClientPropertyBalanceListModel>(
  "PropertyBalancesTableSlice/getBalancesForAllProperties",
  async () => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.getBalancesForAllProperties();
  }
);

export const selectClientPropertyBalances = (state: RootState) => {
  return state.propertyBalancesTable.ClientPropertyBalances;
};

export const selectLoadingClientPropertyBalances = (state: RootState) => {
  return state.propertyBalancesTable.Loading;
};

export default PropertyBalancesTableSlice.reducer;
